import React, { useState } from "react";
import styled from "styled-components";

export default function Input({
  name,
  type,
  onChange,
  placeholder,
  defaultValue,
  label,
  disabled,
}) {
  const [readOnly, setReadOnly] = useState(true);

  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <AppInputStyle
        style={{
          border: `1px solid ${disabled ? "#D0D5DD" : "#28282898"}`,
        }}
      >
        <div>
          <input
            readOnly={readOnly}
            onFocus={() => setReadOnly(false)}
            onBlur={() => setReadOnly(true)}
            autocomplete="off"
            type={type}
            name={name}
            onChange={onChange}
            required
            defaultValue={defaultValue}
            placeholder={placeholder}
            disabled={disabled}
          />
        </div>
      </AppInputStyle>
    </>
  );
}

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
`;
const AppInputStyle = styled.div`
  margin-bottom: 20px;
  margin-top: 10px;
  input {
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    padding: 20px 10px;
    font-size: 16px;
    background-color: white;
    border-radius: 10px;
  }
  input::placeholder {
    color: #ababab;
  }
`;
